import { WixPatternsContainer, QueryState } from '@wix/bex-core';
import { makeObservable, observable } from 'mobx';
import { NestedCollectionNodeState } from './NestedCollectionNodeState';
import { NestedCollectionLevelDescriptor } from './NestedCollectionLevelDescriptor';
import { NodeCollection } from './types';

export interface NestedCollectionStateBaseParams {
  levels: NestedCollectionLevelDescriptor<any, any>[];
  query: QueryState<{}>;
  nodeCollection?: NodeCollection<any, any>;
}

export interface NestedCollectionStateParams
  extends NestedCollectionStateBaseParams {
  readonly container: WixPatternsContainer;
}

export class NestedCollectionState {
  readonly container;

  readonly levels;

  isFetchAllAborted = null as null | boolean;

  _fetchAllTotal = undefined as undefined | number;

  expandAll = true;
  total = 0;

  readonly root: NestedCollectionNodeState<any, any>;
  readonly query;

  constructor(params: NestedCollectionStateParams) {
    const { container } = params;
    this.container = container;

    const rootLevelDescriptor = params.levels[0];

    this.levels = params.levels;
    this.query = params.query;

    this.root = new NestedCollectionNodeState({
      nestedCollection: this,
      parentNode: null,
      parent: null,
      levelDescriptor: rootLevelDescriptor,
      nodeCollection: params.nodeCollection,
    });

    this.root.parentFilter?.setValue(['null']);

    makeObservable(this, {
      total: observable.ref,
    });
  }
}
